import { useId } from "react";

/** The Atzmai mark (distro/brand/out/atzmai-mark.svg in the OS): a mind, the
 *  planet, held inside a boundary it cannot leave, its orbit. `pulse` lets a
 *  soft light breathe out from the planet, as the OS's own planet does. */
export function Mark({ size = 32, pulse = false, className = "" }: { size?: number; pulse?: boolean; className?: string }) {
  const id = useId().replace(/:/g, "");
  return (
    <span className={`mark ${pulse ? "mark-pulse" : ""} ${className}`} style={{ width: size, height: size }} aria-hidden="true">
      <svg viewBox="0 0 256 256" width={size} height={size}>
        <defs>
          <linearGradient id={`${id}o`} x1="0.18" y1="0.12" x2="0.86" y2="0.9">
            <stop offset="0" stopColor="#8f9bff" />
            <stop offset="0.55" stopColor="#6a7cf5" />
            <stop offset="1" stopColor="#22d3ee" />
          </linearGradient>
          <linearGradient id={`${id}r`} x1="0" y1="0" x2="1" y2="0">
            <stop offset="0" stopColor="#7c8cff" />
            <stop offset="1" stopColor="#22d3ee" />
          </linearGradient>
          <radialGradient id={`${id}s`} cx="0.36" cy="0.3" r="0.55">
            <stop offset="0" stopColor="#ffffff" stopOpacity="0.62" />
            <stop offset="0.45" stopColor="#ffffff" stopOpacity="0.08" />
            <stop offset="1" stopColor="#ffffff" stopOpacity="0" />
          </radialGradient>
          <radialGradient id={`${id}d`} cx="0.7" cy="0.78" r="0.6">
            <stop offset="0" stopColor="#05070c" stopOpacity="0.38" />
            <stop offset="1" stopColor="#05070c" stopOpacity="0" />
          </radialGradient>
        </defs>
        {pulse && <circle className="mark-glow" cx="128" cy="128" r="66" fill="#8b97ff" />}
        <g transform="rotate(-22 128 128)">
          <path d="M18,128 A110,38 0 0 1 238,128" fill="none" stroke={`url(#${id}r)`} strokeWidth="9" strokeLinecap="round" opacity="0.38" />
        </g>
        <circle cx="128" cy="128" r="66" fill={`url(#${id}o)`} />
        <circle cx="128" cy="128" r="66" fill={`url(#${id}d)`} />
        <circle cx="128" cy="128" r="66" fill={`url(#${id}s)`} />
        <g transform="rotate(-22 128 128)">
          <path d="M18,128 A110,38 0 0 0 238,128" fill="none" stroke={`url(#${id}r)`} strokeWidth="9" strokeLinecap="round" />
          <circle cx="190" cy="159.5" r="10" fill="#e9ecf6" />
        </g>
      </svg>
    </span>
  );
}
